import { render, staticRenderFns } from "./EfsMdContractPriceListList.vue?vue&type=template&id=63a960bd&scoped=true&"
import script from "./EfsMdContractPriceListList.vue?vue&type=script&lang=js&"
export * from "./EfsMdContractPriceListList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdContractPriceListList.vue?vue&type=style&index=0&id=63a960bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a960bd",
  null
  
)

export default component.exports